export default "__VITE_ASSET__CdWa9bvd__"